import(/* webpackMode: "eager" */ "/app/next/src/app/(site)/error.tsx");
